import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import constant, { ToastType, UserRoles } from "../../helper/constant";
import { useAIModelContext } from "../../context/ai-model.context";
import { useAuthContext } from "../../context/auth.context";
import RecentModels from "./dashboard/RecentModels";
import { useAppContext } from "../../context/app.context";
import { useScreenSizeContext } from "../../context/mobile-layout.context";
import RecentWorkflows from "./dashboard/RecentWorkflows";
import { useAIWorkflowContext } from "../../context/ai-workflow.context";
import DashboardList from "./dashboard/DashboardList";

const Home = () => {
  const { getTemplates, clearModelInfo, templates, isOverviewFirstTime } =
    useAIModelContext();
  const { showAlert } = useAppContext();
  const { isLoggedIn, userInfo } = useAuthContext();
  const { isMobileScreen } = useScreenSizeContext();
  const { getWorkflowList, workflows } = useAIWorkflowContext();

  useEffect(() => {
    clearModelInfo();
  }, []);

  useEffect(() => {
    if (isOverviewFirstTime)
      showAlert("Your business overview is ready!", ToastType.SUCCESS, false);
  }, [isOverviewFirstTime]);

  useEffect(() => {
    if (isLoggedIn) {
      getTemplates();
      getWorkflowList();
    }
  }, [isLoggedIn]);


  const renderHomebanner = () => {
    return (
      <>
        {/* <div className="col-md-4 mx-auto">
          <h1 className="h1 font-weight-bold">Welcome to Avtar AI.</h1>
          {!isMobileScreen && (
            <Link
              to={constant.PAGES.HOME.AI_TEMPLATE}
              className="btn1 mt-3 arrowhover d-flex align-items-center justify-content-between font-weight-bold w-100"
            >
              Create New Pipeline Manually
              <span>
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 45 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M44.0607 13.0607C44.6464 12.4749 44.6464 11.5251 44.0607 10.9393L34.5147 1.3934C33.9289 0.807612 32.9792 0.807612 32.3934 1.3934C31.8076 1.97918 31.8076 2.92893 32.3934 3.51472L40.8787 12L32.3934 20.4853C31.8076 21.0711 31.8076 22.0208 32.3934 22.6066C32.9792 23.1924 33.9289 23.1924 34.5147 22.6066L44.0607 13.0607ZM0 13.5H43V10.5H0V13.5Z"
                    fill="white"
                  />
                </svg>
              </span>
            </Link>
          )}
        </div> */}
        <div className="col-md-3 my-2 mx-auto">
          <Link
            to={`/${constant.PAGES.HOME.BUSINESS_OVERVIEW}`}
            className={`btn1 py-3 px-0 d-flex align-items-center justify-content-center font-weight-bold w-100 text-center`}
          >
            Business Overview{" "}
            {isOverviewFirstTime && <span className="badge-indicator"></span>}
          </Link>
        </div>
      </>
    )
  }

  const renderDashboardSection = () => {
    if (templates && templates.length) {
      return (
        <div className={`${isMobileScreen ? "mx-2" : "mx-5"} `}>
          <DashboardList />
        </div>
      )
    }
  }

  const renderPipelineSection = () => {
    if (templates && templates.length) {
      return (
        <div className={`${isMobileScreen ? "mx-2" : "mx-5"} `}>
          <RecentModels />
        </div>
      )
    }
  }

  const renderWorkflowSection = () => {
    if (workflows && workflows.length) {
      return (
        <div className={`position-relative ${isMobileScreen ? "mx-2" : "mx-5"} pb-5 mx-4 mb-2`}>
          <RecentWorkflows />
        </div>
      )
    }
  }

  const renderHomeTabs = () => {
    return (

      <div className="popuptabs">
        <ul className="nav nav-tabs" id="home-tabs" role="tablist">
          <li className="nav-item">
            <a
              className={`h6 font-weight-bold nav-link capitalize active`}
              id={`Business_Dashboard-tab`}
              data-toggle="tab"
              href='#Business_Dashboard'
              role="tab"
              aria-controls='Business_Dashboard'
              aria-selected="false"
            >
              Applications
            </a>
          </li>
          {
            userInfo &&
            userInfo.org &&
            userInfo.org.role !== UserRoles[1].id && (
              <>
                <li className="nav-item">
                  <a
                    className={`h6 font-weight-bold nav-link capitalize`}
                    id={`Pipeline_Dashboard-tab`}
                    data-toggle="tab"
                    href='#Pipeline_Dashboard'
                    role="tab"
                    aria-controls='Pipeline_Dashboard'
                    aria-selected="false"
                  >
                    Pipeline
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`h6 font-weight-bold nav-link capitalize`}
                    id={`Workflow_Dashboard-tab`}
                    data-toggle="tab"
                    href='#Workflow_Dashboard'
                    role="tab"
                    aria-controls='Workflow_Dashboard'
                    aria-selected="false"
                  >
                    Workflow
                  </a>
                </li>
              </>)
          }
        </ul>
      </div>
    )
  }

  const renderHomeTabsContent = () => {
    return (
      <div className="tab-content" id="home-tab-content">
        <div
          className={`tab-pane fade active show`}
          id='Business_Dashboard'
          role="tabpanel"
          aria-labelledby={`Business_Dashboard-tab`}
        >
          {renderDashboardSection()}
        </div>
        <div
          className={`tab-pane fade`}
          id='Pipeline_Dashboard'
          role="tabpanel"
          aria-labelledby={`Pipeline_Dashboard-tab`}
        >
          {renderPipelineSection()}
        </div>
        <div
          className={`tab-pane fade`}
          id='Workflow_Dashboard'
          role="tabpanel"
          aria-labelledby={`Workflow_Dashboard-tab`}
        >
          {renderWorkflowSection()}
        </div>
      </div>
    )
  }

  const render = () => {
    return (
      <div className="row mx-0 mt-3">
        <div
          className={`col-md-12 px-md-0 ${isMobileScreen ? "p-0 mb-5" : ""}`}
        >
          {renderHomebanner()}
          {renderHomeTabs()}
          {renderHomeTabsContent()}
        </div>
      </div>
    );
  };

  return render();
};

export default Home;
